export const SET_NAME = "bank/SET_NAME";
export const SET_INFO = "bank/SET_INFO";
export const RESET = "bank/RESET";